import React, { useEffect, useContext, useState, useRef, useMemo } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  getMinDateByTime,
} from "../../../../functions/Functions";

//3rd party packages
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useReactToPrint } from "react-to-print";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { FoodContext } from "../../../../contexts/Food";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import { ToastError } from "../../../../functions/ToastShow";

const MenuMixReport = () => {

  const { t } = useTranslation();

  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);

  let { branchForSearch } = useContext(RestaurantContext);
  let { foodForPOS, foodGroupForSearch } = useContext(FoodContext);

  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef2 = useRef();
  const componentRef3 = useRef();
  const componentRef4 = useRef();
  const componentRef5 = useRef();

  const componentRefThermal = useRef();
  const componentRefThermal2 = useRef();
  const componentRefThermal3 = useRef();

  //all data
  const [reportData, setReportData] = useState(null);
  const [itemData, setItemData] = useState(null);
  const [categoryItemData, setCategoryItemData] = useState(null);
  const [categoryWiseData, setCategoryWiseData] = useState(null);

  const [branchDateWise, setBranchDateWise] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [item, setItem] = useState(null);
  const [group, setGroup] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [printReport, setPrintReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [option, setOption] = useState("excel");
  const [reportOption, setReportOption] = useState("menu_mix_report");
  const [menuMixOrderTypeReport, setMenuMixOrderTypeReport] = useState({
    groupReport: null,
    itemReport: null,
  });

  const reportOptionsList = useMemo(() => [
    { value: "menu_mix_report", label: _t(t("Menu Mix")) },
    { value: "category_item_wise", label: _t(t("Category Item Wise")) },
    { value: "category_group_wise", label: _t(t("Category Group Wise")) },
    { value: "item_wise_report", label: _t(t("Item Wise Report")) },
    { value: "menu_mix_date_wise", label: _t(t("Menu Mix Date Wise")) },
    { value: "menu_mix_order_type", label: _t(t("Menu Mix Order Type")) },
  ], [t]);


  useEffect(() => {

    setSiteName(getSystemSettings(generalSettings, "siteName"));
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 500);

  }, [generalSettings]);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `@page {margin: 5px;}`,
  });

  const printMenuMixOrderTypeReport = useReactToPrint({
    content: () => componentRefThermal2.current,
    pageStyle: `@page {margin: 5px;}`,
  });

  const printMenuMixCategoryWiseReport = useReactToPrint({
    content: () => componentRefThermal3.current,
    pageStyle: `@page {margin: 5px;}`,
  });

  const handleBranch = (branch) => {
    setBranch(branch)
  }

  const handleGroup = (grp) => {
    setGroup(grp)
  }

  const handleItem = (item) => {
    setItem(item)
  }

  const handleOption = (e) => {
    setOption(e.target.value)
  }

  const handleSetOption = (e) => {
    setReportOption(e.value)
    if(e.value !== reportOption){
      setGroup(null)
    }
  }

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    setGeneratedReport(false)
    setPrintReport(false)
    if (
      startDate !== null &&
      endDate !== null
    ) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/get-item-menu-mix-category-report";
      const bId = branch && branch?.length ? branch.map((b)=>b.id) : "";
      const formData = {
        fromDate: fromDate,
        toDate: toDate,
        branch_id: bId,
        food_group : group ? group?.name : "",
        item: item ? item?.name : ""
      }

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("ReportResult", res);
          setReportData(res.data)
          setDataPaginating(false);
          if (option === "excel") {
            setGeneratedReport(true);
            componentRef.current.handleDownload();
          } else {
            setPrintReport(true)
            thermalPrint();
          }
        })
        .catch((error) => {
          if(error.response?.data?.status === 0){
            ToastError({
              title: _t(t(error.response?.data?.message)),
            })
            return
          }
          setDataPaginating(false);
        });
    } else {

      ToastError({
        title: _t(t("Please select from date and to date")),
      })

    }
  };

  const getBranchItemWise = () => {
    setItemData(null);
    setGeneratedReport(false)
    if (
      startDate !== null &&
      endDate !== null
    ) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/get-item-wise-report";
      const bId = branch && branch?.length ? branch.map((b)=>b.id) : "";
      const formData = {
        fromDate: fromDate,
        toDate: toDate,
        branch_id: bId,
        item: item ? item?.name : ""
      }

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGeneratedReport(true);
          setItemData(res.data[0])
          setDataPaginating(false);
          componentRef1.current.handleDownload();

        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      ToastError({
        title: _t(t("Please select from date and to date")),
      })
    }
  };

  const getBranchCategoryItemWise = () => {
    setCategoryItemData(null);
    setGeneratedReport(false)
    if (
      startDate !== null &&
      endDate !== null
    ) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/get-daily-bill-item-menuMix-report";
      const bId = branch && branch?.length ? branch.map((b)=>b.id) : "";
      const formData = {
        fromDate: fromDate,
        toDate: toDate,
        branch_id: bId,
      }

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGeneratedReport(true);
          setCategoryItemData(res.data)
          setDataPaginating(false);
          componentRef3.current.handleDownload();

        })
        .catch((error) => {
          if(error.response?.data?.status === 0){
            ToastError({
              title: _t(t(error.response?.data?.message)),
            })
            return
          }
          setDataPaginating(false);
        });
    } else {
      ToastError({
        title: _t(t("Please select from date and to date")),
      })

    }
  }

  const getBranchDateWise = () => {
    setBranchDateWise(null);
    setGeneratedReport(false)
    if (
      startDate !== null &&
      endDate !== null
    ) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/get-menu-mix-date-wise-report";

      const bId = branch && branch?.length ? branch.map((b)=>b.id) : "";
      const formData = {
        fromDate: fromDate,
        toDate: toDate,
        branch_id: bId,
        item: item ? item?.name : ""
      }

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGeneratedReport(true);
          setBranchDateWise(res.data)
          setDataPaginating(false);
          componentRef2.current.handleDownload();

        })
        .catch((error) => {
          setDataPaginating(false);
          if(error.response?.data?.status === 0){
            ToastError({
              title: _t(t(error.response?.data?.message)),
            })
            return
          }
        });
    } else {
      ToastError({
        title: _t(t("Please select from date and to date")),
      })
    }
  };

  const getReportMenuMixOrderType = () => {

    if (!startDate || !endDate) {
      ToastError({ title: _t(t("Please select from date and to date")) })
      return;
    }

    setMenuMixOrderTypeReport({
      groupReport: null,
      itemReport: null,
    });

    setGeneratedReport(false)
    setPrintReport(false)
    setDataPaginating(true);

    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");

    const url = BASE_URL + "/settings/get-foodItem-rpt-menuMix-report";
    
    const bId = branch && branch?.length ? branch.map((b)=>b.id) : "";
    const formData = {
      fromDate: fromDate,
      toDate: toDate,
      branch_id: bId,
      item: item ? item?.name : ""
    }

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {

        setMenuMixOrderTypeReport({
          groupReport: res.data[0],
          itemReport: res.data[1],
        })

        setGeneratedReport(true);
        setDataPaginating(false);

        if (option === "excel") {
          componentRef4.current.handleDownload();
        } else {
          printMenuMixOrderTypeReport();
        }

      })
      .catch((error) => {
        if(error.response?.data?.status === 0){
          ToastError({
            title: _t(t(error.response?.data?.message)),
          })
          return
        }
        setDataPaginating(false);
      });

  };

  const getReportMenuMixCategoryWise = () => {

    if (!startDate || !endDate) {
      ToastError({ title: _t(t("Please select from date and to date")) })
      return;
    }

    setCategoryWiseData(null);
    setGeneratedReport(false)
    setPrintReport(false)
    setDataPaginating(true);

    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");

    const url = BASE_URL + "/settings/get-bill-item-menuMix-report";

    const bId = branch && branch?.length ? branch.map((b)=>b.id) : "";
    const category = group?.length ? group.map((itm)=>itm.name) : "";
    const formData = {
      fromDate: fromDate,
      toDate: toDate,
      branch_id: bId,
      item: item ? item?.name : "",
      food_groups: category
    }

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res?.data && res.status == 200) {
          setCategoryWiseData(res?.data)
          setGeneratedReport(true);
          setDataPaginating(false);

          if (option === "excel") {
            componentRef5.current.handleDownload();
          } else {
            printMenuMixCategoryWiseReport();
          }
          return
        }
        throw new Error("Something went wrong");
      })
      .catch((error) => {
        setDataPaginating(false);
        if(error.response?.data?.status === 0){
          ToastError({
            title: _t(t(error.response?.data?.message)),
          })
          return
        }
        ToastError({ title: t(`Please try again`) })
      });

  };


  const handleCheckReport = (e) => {

    e.preventDefault();

    switch (reportOption) {
      case "menu_mix_date_wise":
        getBranchDateWise();
        break;

      case "item_wise_report":
        getBranchItemWise();
        break;

      case "category_item_wise":
        getBranchCategoryItemWise();
        break;

      case "menu_mix_order_type":
        getReportMenuMixOrderType();
        break;

      case "category_group_wise":
        getReportMenuMixCategoryWise();
        break;

      default:
        getBranchWiseSelected();
        break;
    }

  };


  return (
    <>
      <Helmet>
        <title>{_t(t("Menu Mix Report"))}</title>
      </Helmet>

      {/* Excel Report of Menu Mix Report */}
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Menu Mix Report"
        sheet="sheet 1"
        buttonText="Menu Mix Detail"
        ref={componentRef}
      />

      <MenuMixReportTable
        reportData={reportData}
        generatedReport={generatedReport}
        branch={branch}
        startDate={startDate}
        endDate={endDate}
        siteName={siteName}
        t={t}
        refThermal={componentRefThermal}
        printReport={printReport}
      />

      {/* Excel Report of Menu Mix Item Wise Report */}
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="item-to-xls"
        filename="Menu Mix Item Wise Report"
        sheet="sheet 1"
        buttonText="Item Wise Detail"
        ref={componentRef1}
      />

      <MenuMixItemWiseReportTable
        itemData={itemData}
        generatedReport={generatedReport}
        branch={branch}
        startDate={startDate}
        endDate={endDate}
        siteName={siteName}
        t={t}
      />


      {/* Excel Report of Menu Mix Date Wise Report */}
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="branch-to-xls"
        filename="Menu Mix Date Wise Report"
        sheet="sheet 1"
        buttonText="Branch Wise Detail"
        ref={componentRef2}
      />

      <MenuMixDateWiseReportTable
        branchDateWise={branchDateWise}
        generatedReport={generatedReport}
        branch={branch}
        startDate={startDate}
        endDate={endDate}
        siteName={siteName}
        t={t}
      />

      {/* Excel Report of Menu Mix Category Item Wise Report */}
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="category-to-xls"
        filename="Menu Mix Category Item Wise Report"
        sheet="sheet 1"
        buttonText="Category Item Wise"
        ref={componentRef3}
      />

      <MenuMixCategoryWiseReportTable
        categoryItemData={categoryItemData}
        generatedReport={generatedReport}
        branch={branch}
        startDate={startDate}
        endDate={endDate}
        siteName={siteName}
        t={t}
      />


      {/* Excel Report of Menu Mix Order Type Report */}
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="menu-mix-order-type-to-xls"
        filename="Menu Mix Report"
        sheet="sheet 1"
        buttonText="Menu Mix Detail"
        ref={componentRef4}
      />

      <MenuMixOrderTypeTable
        menuMixOrderTypeReport={menuMixOrderTypeReport}
        generatedReport={generatedReport}
        branch={branch}
        startDate={startDate}
        endDate={endDate}
        siteName={siteName}
        t={t}
        refThermal={componentRefThermal2}
      />

      {/* Excel Report of Menu Mix Category Group Wise Report */}
      <ReactHTMLTableToExcel
        id="menu-mix-category-wise-to-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="menu-mix-category-wise-to-xls"
        filename="Menu Mix Category Group Wise Report"
        sheet="sheet 1"
        buttonText="Menu Mix Detail"
        ref={componentRef5}
      />

      <MenuMixCategoryWiseTable
        menuMixCategoryWiseReport={categoryWiseData}
        generatedReport={generatedReport}
        branch={branch}
        startDate={startDate}
        endDate={endDate}
        siteName={siteName}
        t={t}
        refThermal={componentRefThermal3}
        reportViewOption={option}
      />


      {/* =================================================== */}



      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0" >
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Menu Mix Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end p-0">
                            <div className="d-inline mr-3 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="excel_report"
                                name="excel_report"
                                value="excel"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={
                                  option === "excel"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="excel_report"
                                style={{ fontSize: "16px", borderRadius: "5px" }}
                              >
                                <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                              </label>
                            </div>

                            <div className="d-inline mr-2 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="print_report"
                                name="print_report"
                                value="print"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={
                                  option === "print"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="print_report"
                                style={{ fontSize: "16px", borderRadius: "5px" }}
                              >
                                <i className="fa fa-print" aria-hidden="true"></i> {_t(t("Print"))}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={true}
                            // minDate={getMinDateByTime()}
                          />
                        </div>

                        <div className="col-2 ">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={true}
                            // minDate={getMinDateByTime()}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch || []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            isMulti
                            value={branch}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={reportOptionsList}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            value={reportOptionsList.find(op => op.value === reportOption)}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleSetOption}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select Report Type")) + ".."}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={foodGroupForSearch ?? []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            isMulti={reportOption === "category_group_wise"}
                            value={group}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleGroup}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select category")) + ".."}
                          />
                        </div>

                        <div className="col-2 mt-2">
                          <Select
                            options={foodForPOS ?? []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={item}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleItem}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select item")) + ".."}
                          />
                        </div>

                        <div className="col-8 mt-2"></div>

                        <div className="col-2 mt-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => handleCheckReport(e)}
                          >
                            PRINT REPORT
                          </button>
                        </div>
                      </div>
                      <div className="mt-3 d-flex justify-content-end">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main >
    </>
  );
};

export default MenuMixReport;

const MenuMixItemWiseReportTable = ({
  itemData,
  generatedReport,
  branch,
  startDate,
  endDate,
  siteName,
  t
}) => {
  return (
    <>
      <div className="d-none">
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {itemData !== null &&
                  itemData !== undefined &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="item-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="6" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Item Wise Menu Mix Report
                                      </h3>
                                      <h4 className="text-center mt-0">
                                        {branch && branch.name}
                                      </h4>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">
                                          {startDate}
                                        </Moment>
                                        &nbsp;TO&nbsp;
                                        <Moment format="LL">{endDate}</Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th scope="col">{_t(t("Branch"))}</th>
                                <th scope="col">{_t(t("S/L"))}</th>
                                <th scope="col">{_t(t("Barcode"))}</th>
                                <th scope="col">{_t(t("Item"))}</th>
                                <th scope="col">{_t(t("Single"))}</th>
                                <th scope="col">{_t(t("Deal"))}</th>
                                <th scope="col">{_t(t("Total"))}</th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {Object.keys(itemData).map((grp, index) => {
                                return (
                                  <div>
                                    <tr key={index}>
                                      <th>{grp}</th>
                                    </tr>

                                    {itemData[grp].map((item, i) => {
                                      const Qty =
                                        parseFloat(item.deal) +
                                        parseFloat(item.single);

                                      return (
                                        <tr key={i}>
                                          <td></td>
                                          <td>{i + 1}</td>
                                          <td scope="row">
                                            {item?.barcode}
                                          </td>
                                          <td scope="row">
                                            {item.food_item}
                                          </td>
                                          <td scope="row">{item.single}</td>
                                          <td scope="row">{item.deal}</td>
                                          <td scope="row">
                                            <strong>{Qty}</strong>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </tbody>

                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="4"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">
                                    Powered by indolj.pk
                                  </h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const MenuMixReportTable = ({
  reportData,
  generatedReport,
  branch,
  startDate,
  endDate,
  siteName,
  t,
  refThermal,
  printReport,
}) => {
  let g_total_qty = 0;
  let g_total_amount = 0;

  return (
    <>
      <div className="d-none">
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {reportData !== null &&
                  reportData !== undefined &&
                  reportData &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="8" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Menu Mix Report
                                      </h3>
                                      <h4 className="text-center mt-0">
                                        {branch && branch.name}
                                      </h4>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">
                                          {startDate}
                                        </Moment>
                                        &nbsp;TO&nbsp;
                                        <Moment format="LL">{endDate}</Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th scope="col">{_t(t("Branch"))}</th>
                                <th scope="col">{_t(t("Group Name"))}</th>
                                <th scope="col">{_t(t("Item Id"))}</th>
                                <th scope="col">{_t(t("Item"))}</th>
                                <th scope="col">{_t(t("Qty"))}</th>
                                <th scope="col">{_t(t("Cost Price"))}</th>
                                <th scope="col">{_t(t("Price"))}</th>
                                <th scope="col">{_t(t("Amount"))}</th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* {console.log("309 ", reportData)} */}
                              {/* loop here*/}
                              {reportData[0] &&
                                Object.keys(reportData[0]).length > 0 &&
                                Object.keys(reportData[0]).map(
                                  (branch_name, ind) => {
                                    return (
                                      <>
                                        <tr key={ind}>
                                          <th
                                            scope="row"
                                            className="lg-text text-capitalize align-middle text-center"
                                          >
                                            {branch_name}
                                          </th>
                                        </tr>
                                        {Object.keys(
                                          reportData[0][branch_name]
                                        ).length > 0 &&
                                          Object.keys(
                                            reportData[0][branch_name]
                                          ).map((group_name, index) => {
                                            let totalQty = 0;
                                            let totalAmount = 0;
                                            return (
                                              <>
                                                <tr key={index}>
                                                  <th></th>
                                                  <th scope="row">
                                                    {group_name}
                                                  </th>
                                                </tr>
                                                {reportData[0][branch_name][
                                                  group_name
                                                ]?.length > 0 &&
                                                  reportData[0][branch_name][
                                                    group_name
                                                  ].map((item, i) => {
                                                    totalQty += parseFloat(
                                                      item.qty
                                                    );
                                                    totalAmount += parseFloat(
                                                      item.amount
                                                    );
                                                    g_total_qty += parseFloat(
                                                      item.qty
                                                    );
                                                    g_total_amount +=
                                                      parseFloat(item.amount);
                                                    let price =
                                                      item.amount > 0 &&
                                                        item.qty > 0
                                                        ? parseFloat(
                                                          item.amount
                                                        ) /
                                                        parseFloat(item.qty)
                                                        : 0;

                                                    return (
                                                      <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td scope="row">
                                                          {item?.item_id}
                                                        </td>
                                                        <td scope="row">
                                                          {item.item_name}
                                                        </td>
                                                        <td scope="row">
                                                          {item.qty}
                                                        </td>
                                                        <td scope="row">
                                                          {formatPrice(
                                                            item?.cost_price ||
                                                            0
                                                          )}
                                                        </td>
                                                        <td scope="row">
                                                          {formatPrice(price)}
                                                        </td>
                                                        <td scope="row">
                                                          {item.amount}
                                                        </td>
                                                      </tr>
                                                    );
                                                  })}
                                                <tr>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <th scope="row">Total</th>
                                                  <td scope="row">
                                                    <strong>
                                                      {formatPrice(totalQty)}
                                                    </strong>
                                                  </td>
                                                  <td></td>
                                                  <td></td>
                                                  <td scope="row">
                                                    <strong>
                                                      {formatPrice(
                                                        totalAmount
                                                      )}
                                                    </strong>
                                                  </td>
                                                </tr>
                                              </>
                                            );
                                          })}
                                      </>
                                    );
                                  }
                                )}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <th scope="row">Grand Total</th>
                                <td scope="row">
                                  <strong>{formatPrice(g_total_qty)}</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td scope="row">
                                  <strong>
                                    {formatPrice(g_total_amount)}
                                  </strong>
                                </td>
                              </tr>
                              {reportData[1] &&
                                Object.keys(reportData[1]).length > 0 &&
                                Object.keys(reportData[1]).map(
                                  (branch_name, ind) => {
                                    return (
                                      <>
                                        <tr></tr>
                                        <tr key={ind}>
                                          <th colSpan={7}>{branch_name}</th>
                                        </tr>
                                        {reportData[1][branch_name] &&
                                          reportData[1][branch_name]?.length >
                                          0 && (
                                            <tr>
                                              <th scope="row" colSpan={7}>
                                                Details
                                              </th>
                                            </tr>
                                          )}
                                        {reportData[1][branch_name] &&
                                          reportData[1][branch_name]?.length >
                                          0 && (
                                            <tr>
                                              <th scope="col" colSpan={4}>
                                                {_t(t("Item"))}
                                              </th>
                                              <th scope="col" colSpan={3}>
                                                {_t(t("Qty"))}
                                              </th>
                                              <th scope="col" colSpan={3}>
                                                {_t(t("Price"))}
                                              </th>
                                              <th scope="col" colSpan={3}>
                                                {_t(t("Amount"))}
                                              </th>
                                            </tr>
                                          )}
                                        {reportData[1][branch_name] &&
                                          reportData[1][branch_name]?.length >
                                          0 &&
                                          reportData[1][branch_name].map(
                                            (value, ind) => {
                                              const price =(value.amount > 0 &&
                                                  value.qty > 0)
                                                  ? (parseFloat(
                                                    value.amount
                                                  ) /
                                                  parseFloat(value.qty))
                                                  : 0;
                                              return (
                                                <tr key={ind}>
                                                  <td scope="row" colSpan={4}>
                                                    {value.item_name}
                                                  </td>
                                                  <td scope="row" colSpan={3}>
                                                    {value.qty}
                                                  </td>
                                                  <td scope="row" colSpan={3}>
                                                    {price}
                                                  </td>
                                                  <td scope="row" colSpan={3}>
                                                    {value.amount}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}

                                        {reportData[2] &&
                                          reportData[2][branch_name] &&
                                          reportData[2][branch_name]?.length >
                                          0 && (
                                            <tr>
                                              <th scope="row" colSpan={7}>
                                                Deals Details
                                              </th>
                                            </tr>
                                          )}
                                        {reportData[2] &&
                                          reportData[2][branch_name] &&
                                          reportData[2][branch_name]?.length >
                                          0 && (
                                            <tr>
                                              <th scope="col" colSpan={4}>
                                                {_t(t("Item"))}
                                              </th>
                                              <th scope="col" colSpan={3}>
                                                {_t(t("Qty"))}
                                              </th>
                                            </tr>
                                          )}
                                        {reportData[2] &&
                                          reportData[2][branch_name] &&
                                          reportData[2][branch_name]?.length >
                                          0 &&
                                          reportData[2][branch_name].map(
                                            (value, ind) => {
                                              return (
                                                <tr key={ind}>
                                                  <td scope="row" colSpan={4}>
                                                    {value.item_name}
                                                  </td>
                                                  <td scope="row" colSpan={3}>
                                                    {value.qty}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                      </>
                                    );
                                  }
                                )}
                            </tbody>

                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="7"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">
                                    Powered by indolj.pk
                                  </h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>

        <div ref={refThermal}>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      {siteName}
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      FROM&nbsp;
                      <Moment format="LL">{startDate}</Moment>
                      &nbsp;TO&nbsp;
                      <Moment format="LL">{endDate}</Moment>
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      Print Time: <Moment format="LLL">{new Date()}</Moment>
                    </span>
                  </div>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    Menu Mix Report
                  </span>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    {branch?.name}
                  </span>
                  {/*catg wise report */}
                  <div className="col-12">
                    {reportData && reportData !== null && printReport && (
                      <div>
                        <p className="mx-1 xsm-text table-text_pos text-capitalize border border-dark py-1 d-flex justify-content-between">
                          <span
                            className="font-weight-bold pl-1"
                            style={{ width: "40.5%" }}
                          >
                            Item
                          </span>
                          <span
                            className="font-weight-bold"
                            style={{ width: "19%" }}
                          >
                            Qty
                          </span>

                          <span
                            className="font-weight-bold"
                            style={{ width: "22.5%" }}
                          >
                            Price
                          </span>

                          <span
                            className="font-weight-bold pr-1"
                            style={{ width: "18%", textAlign: "right" }}
                          >
                            Amount
                          </span>
                        </p>
                      </div>
                    )}
                    {reportData &&
                      reportData !== null &&
                      printReport &&
                      Object.keys(reportData[0])?.map((branch) => {
                        let totalMenuGroupQty = 0;
                        let totalMenuGroupPrice = 0;
                        return (
                          <>
                            <div className="w-100 col-12 mt-2">
                              <span className="mx-2 d-flex font-weight-bold fk-print-text_pos justify-content-center lg-text">
                                {branch}
                              </span>
                            </div>
                            {Object.keys(reportData[0][branch])?.map(
                              (group) => {
                                let menuGroupQty = 0;
                                let menuGroupPrice = 0;
                                return (
                                  <div>
                                    <div className="w-100 col-12">
                                      <span className="mx-2 d-flex font-weight-bold fk-print-text_pos justify-content-center text-decoration-underline table-text">
                                        {group}
                                      </span>
                                    </div>
                                    {reportData[0][branch][group]?.map(
                                      (item) => {
                                        let price =
                                          item.amount > 0 && item.qty > 0
                                            ? parseFloat(item.amount) /
                                            parseFloat(item.qty)
                                            : 0;
                                        menuGroupQty += parseInt(item.qty);
                                        menuGroupPrice += parseFloat(
                                          item.amount
                                        );
                                        totalMenuGroupQty += parseInt(item.qty);
                                        totalMenuGroupPrice += parseFloat(
                                          item.amount
                                        );
                                        let lowerCaseItem =
                                          item?.item_name?.toLowerCase();
                                        let boldItem =
                                          lowerCaseItem?.includes("deal");
                                        return (
                                          <div className="text-capitalize w-100 d-flex justify-content-between py-1">
                                            <span
                                              className={`mx-1 sm-text ${boldItem && "font-weight-bold"
                                                }`}
                                              style={{ width: "40.2%" }}
                                            >
                                              {item?.item_name}
                                            </span>
                                            <span
                                              className={`mx-1 sm-text ${boldItem && "font-weight-bold"
                                                }`}
                                              style={{ width: "17%" }}
                                            >
                                              {item.qty}
                                            </span>
                                            <span
                                              className={`mx-1 sm-text ${boldItem && "font-weight-bold"
                                                }`}
                                              style={{ width: "24%" }}
                                            >
                                              {price?.toFixed(2)}
                                            </span>
                                            <span
                                              className={`float-right sm-text pr-1 ${boldItem && "font-weight-bold"
                                                }`}
                                              style={{
                                                width: "18%",
                                                textAlign: "right",
                                              }}
                                            >
                                              {parseFloat(item.amount)?.toFixed(
                                                2
                                              )}
                                            </span>
                                          </div>
                                        );
                                      }
                                    )}
                                    <div className="mb-1 xsm-text fk-print-text_pos fk-print-text--bold text-capitalize d-flex justify-content-between border border-dark">
                                      <span style={{ width: "41.5%" }}>
                                        Total
                                      </span>
                                      <span
                                        className="mx-2 ml-1"
                                        style={{ width: "17%" }}
                                      >
                                        {menuGroupQty}
                                      </span>
                                      <span style={{ width: "23%" }}></span>
                                      <span
                                        className="float-right"
                                        style={{
                                          width: "18%",
                                          textAlign: "right",
                                        }}
                                      >
                                        {menuGroupPrice?.toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                );
                              }
                            )}
                            {reportData !== null && reportData && (
                              <div>
                                <p className="mb-1 sm-text fk-print-text_pos fk-print-text--bold">
                                  {" "}
                                  Grand Total{" "}
                                </p>
                                <div className="mb-1 xsm-text fk-print-text_pos fk-print-text--bold text-capitalize d-flex justify-content-between border border-dark">
                                  <span style={{ width: "41.5%" }}>
                                    Grand Total{" "}
                                  </span>
                                  <span
                                    className="mx-2 ml-1"
                                    style={{ width: "17%" }}
                                  >
                                    {totalMenuGroupQty}
                                  </span>
                                  <span style={{ width: "23%" }}></span>
                                  <span
                                    className="float-right"
                                    style={{ width: "18%", textAlign: "right" }}
                                  >
                                    {totalMenuGroupPrice?.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })}
                    {reportData &&
                      reportData !== null &&
                      printReport &&
                      reportData[1] &&
                      Object.keys(reportData[1])?.map((branch) => {
                        return (
                          <>
                            <div className="w-100 col-12 mt-3">
                              <span className="mx-2 d-flex font-weight-bold fk-print-text_pos justify-content-center lg-text">
                                {branch}
                              </span>
                            </div>
                            {reportData !== null &&
                              reportData[1][branch] &&
                              reportData[1][branch]?.length > 0 && (
                                <>
                                  <span className="mx-2 my-2 d-flex font-weight-bold fk-print-text_pos justify-content-center text-decoration-underline table-text">
                                    Details
                                  </span>
                                  <div>
                                    <p className="mb-1 table-text text-capitalize d-flex justify-content-between border border-dark py-1">
                                      <span className="font-weight-bold mx-2">
                                        Item
                                      </span>

                                      <span className="font-weight-bold pr-1">
                                        Qty
                                      </span>
                                    </p>
                                  </div>
                                  {
                                    reportData[1][branch].map((item) => {
                                      return (
                                        <div className="mb-1 print-text text-capitalize d-flex justify-content-between w-100">
                                          <span className="mx-2 print-text fk-print-text_pos--bold" >{item.item_name}</span>
                                          <span className="mx-2 print-text fk-print-text_pos--bold pr-1" style={{ textAlign: "right" }}>{item.qty}</span>
                                        </div>
                                      )
                                    })
                                  }
                                </>
                              )}
                            {reportData !== null &&
                              reportData[2] &&
                              reportData[2][branch] &&
                              reportData[2][branch]?.length > 0 && (
                                <>
                                  <span className="mx-2 my-2 d-flex font-weight-bold fk-print-text_pos justify-content-center text-decoration-underline table-text">
                                    Deals Details
                                  </span>
                                  <div>
                                    <p className="mb-1 table-text text-capitalize d-flex justify-content-between border border-dark py-1">
                                      <span className="font-weight-bold mx-2">
                                        Item
                                      </span>

                                      <span className="font-weight-bold pr-1">
                                        Qty
                                      </span>
                                    </p>
                                  </div>
                                  {
                                    reportData[2][branch].map((item) => {
                                      return (
                                        <div className="mb-1 print-text text-capitalize d-flex justify-content-between w-100">
                                          <span className="mx-2 print-text fk-print-text_pos--bold" >{item.item_name}</span>
                                          <span className="mx-2 print-text fk-print-text_pos--bold pr-1" style={{ textAlign: "right" }}>{item.qty}</span>
                                        </div>
                                      )
                                    })
                                  }
                                </>
                              )}
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const MenuMixDateWiseReportTable = ({
  branchDateWise,
  generatedReport,
  branch,
  startDate,
  endDate,
  siteName,
  t
}) => {
  return (
    <>
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {branchDateWise !== null &&
                    branchDateWise !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="branch-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan={branchDateWise[0].length + 3} style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Menu Mix Date Wise Report
                                        </h3>
                                        <h4 className="text-center mt-0">
                                          {branch && branch.name}
                                        </h4>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Food Item"))}
                                  </th>
                                  {
                                    branchDateWise[0].map(item => {
                                      return (
                                        <th
                                          scope="col"
                                        >
                                          {_t(t(item))}
                                        </th>
                                      )
                                    })
                                  }
                                </tr>
                              </thead>
                              <tbody className="align-middle">

                                {
                                  Object.keys(branchDateWise[1]).map((grp, index) => {
                                    return (
                                      <>
                                        <tr key={index}>
                                          <th>{grp}</th>
                                        </tr>

                                        {branchDateWise[1][grp].map((item, i) => {
                                          return (
                                            <tr key={i}>
                                              <td></td>
                                              <td>{i + 1}</td>
                                              <td
                                                scope="row"
                                              >
                                                {item.food_item}
                                              </td>
                                              {
                                                branchDateWise[0].map(key => {
                                                  return (
                                                    <td
                                                      scope="row"
                                                    >
                                                      {item[key] ? item[key] : "-"}
                                                    </td>
                                                  )
                                                })
                                              }
                                            </tr>
                                          );
                                        })}
                                        <tr></tr>
                                      </>
                                    )
                                  })
                                }
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="4"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const MenuMixCategoryWiseReportTable = ({
  categoryItemData,
  generatedReport,
  branch,
  startDate,
  endDate,
  siteName,
  t
}) => {
  let dailyTotalQty = 0;
  return (
    <>
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {categoryItemData !== null &&
                    categoryItemData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="category-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="4" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Category Item Wise Menu Mix Report
                                        </h3>
                                        <h4 className="text-center mt-0">
                                          {branch && branch.name}
                                        </h4>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Category"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Item Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Sold Qty"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {categoryItemData.map((item, i) => {
                                  dailyTotalQty += Number(item.quantity)
                                  return (
                                    <tr key={i}>
                                      <td
                                        scope="row"
                                      >
                                        {item.branch.name}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.food_group}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.food_item}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <strong>
                                          {item.quantity}
                                        </strong>
                                      </td>

                                    </tr>
                                  );
                                })}
                                <tr>
                                  <td></td>
                                  <td colSpan={2}><strong>Total</strong></td>
                                  <td><strong>{dailyTotalQty}</strong></td>
                                </tr>

                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="4"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const MenuMixOrderTypeTable = ({
  menuMixOrderTypeReport,
  generatedReport,
  branch,
  startDate,
  endDate,
  siteName,
  t,
  refThermal,
}) => {

  let grandQty = 0;
  let grandAmount = 0;

  return (
    <>
      <div className="d-none">

        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {(menuMixOrderTypeReport?.groupReport || menuMixOrderTypeReport?.itemReport) && generatedReport && (
                  <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                    <div className="col-12 t-mb-15 mb-md-0 table-responsive">

                      <table
                        className="table table-bordered table-hover min-table-height mt-3"
                        id="menu-mix-order-type-to-xls"
                      >

                        <thead className="align-middle">
                          <tr style={{ border: "0px" }}>
                            <th colSpan="7" style={{ border: "0px" }}>
                              <div className="row">
                                <div className="col-12">
                                  <h3 className="text-center mb-0">{siteName}</h3>
                                  <h3 className="text-center mt-0">Menu Mix Order Type Report</h3>
                                  <h4 className="text-center mt-0">{branch?.name}</h4>
                                  <p className="text-center">
                                    FROM <Moment format="LL">{startDate}</Moment>
                                    &nbsp;TO&nbsp;
                                    <Moment format="LL">{endDate}</Moment>
                                  </p>
                                </div>
                              </div>
                            </th>
                          </tr>

                          <tr>
                            <th>{t("Branch")}</th>
                            <th>{t("Order Type")}</th>
                            <th>{t("Group Name")}</th>
                            <th>{t("Item")}</th>
                            <th>{t("Qty")}</th>
                            <th>{t("Price")}</th>
                            <th>{t("Amount")}</th>
                          </tr>
                        </thead>


                        <tbody className="align-middle">

                          {/* Branch Loop for Group Report */}
                          {menuMixOrderTypeReport?.groupReport && Object.entries(menuMixOrderTypeReport?.groupReport).map(([branchName, orderTypes], bIndex) => (

                            <React.Fragment key={bIndex}>
                              {/* Order Types Loop */}
                              {Object.entries(orderTypes).map(([orderTypeName, groups], otIndex) => {
                                let orderTypeQty = 0;
                                let orderTypeAmount = 0;

                                return (
                                  <React.Fragment key={otIndex}>
                                    {/* Groups Loop */}
                                    {Object.entries(groups).map(([groupName, items], gIndex) => {


                                      return (
                                        <React.Fragment key={gIndex}>
                                          {/* Items Loop */}
                                          {items.map((item, iIndex) => {
                                            const qty = item.total_quantity;
                                            const amount = item.total_price;
                                            const price = qty > 0 ? amount / qty : 0;

                                            orderTypeQty += qty;
                                            orderTypeAmount += amount;

                                            grandQty += qty;
                                            grandAmount += amount;

                                            return (
                                              <tr key={iIndex}>
                                                {/* Branch Name */}
                                                {otIndex === 0 && gIndex === 0 && iIndex === 0 ? <th className="text-capitalize">{branchName}</th> : <td></td>}

                                                {/* Order Type Name */}
                                                {<th>{orderTypeName}</th>}

                                                {/* Group Name */}
                                                <th>{groupName}</th>

                                                {/* Item Name */}
                                                {
                                                  item.food_type === "food" ? (
                                                    <td><strong>{item.food_item}</strong></td>
                                                  ) : item.food_type === "property" ? <td>{'\u200B\u3000'}{item.food_item}</td> : <td>{item.food_item}</td>
                                                }

                                                {/* Quantity */}
                                                <td>{qty}</td>
                                                {/* Price */}
                                                <td>{formatPrice(price)}</td>
                                                {/* Amount */}
                                                <td>{formatPrice(amount)}</td>
                                              </tr>
                                            );
                                          })}
                                        </React.Fragment>
                                      );
                                    })}

                                    {/* Order Type Group Total Row */}
                                    <tr style={{ background: "#e7f3f9" }}>
                                      {/* Branch Name and OrderType Name cells only for first order type group */}
                                      <td></td>
                                      <td colSpan={2}><strong>{orderTypeName} {t('Total')}</strong></td>
                                      <td></td>
                                      <td><strong>{orderTypeQty}</strong></td>
                                      <td></td>
                                      <td><strong>{formatPrice(orderTypeAmount)}</strong></td>
                                    </tr>
                                    <tr></tr>

                                  </React.Fragment>
                                );
                              })}
                            </React.Fragment>
                          ))}

                          {/* Group Report Grand Total */}
                          <tr style={{ background: "#f8f9fa" }}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <th>Grand Total</th>
                            <td><strong>{grandQty}</strong></td>
                            <td></td>
                            <td><strong>{formatPrice(grandAmount)}</strong></td>
                          </tr>

                          {/* Reset Grand Totals for Item Wise Report */}
                          {(() => { grandQty = 0; grandAmount = 0; return null; })()}
                          <tr></tr>
                          <tr></tr>
                          <tr>
                            <th colSpan="7" className="text-center"><h3>Order Type Wise Report</h3></th>
                          </tr>
                          <tr>
                            <th>{t("Branch")}</th>
                            <th>{t("Order Type")}</th>
                            <th>{t("Item")}</th>
                            <th>{t("Qty")}</th>
                            <th>{t("Price")}</th>
                            <th>{t("Amount")}</th>
                          </tr>

                          {/* Branch Loop for Item Report */}
                          {menuMixOrderTypeReport?.itemReport && Object.entries(menuMixOrderTypeReport?.itemReport).map(([branchName, orderTypes], bIndex) => {
                            let branchTotalQty = 0;
                            let branchTotalAmount = 0;

                            // Calculate Branch Totals
                            Object.values(orderTypes).forEach(items => {
                              items.forEach(item => {
                                branchTotalQty += parseFloat(item.total_quantity || 0);
                                branchTotalAmount += parseFloat(item.total_price || 0);
                              });
                            });

                            return (
                              <React.Fragment key={`item-rep-${bIndex}`}>
                                {Object.entries(orderTypes).map(([orderTypeName, items], otIndex) => {
                                  let orderTypeQty = 0;
                                  let orderTypeAmount = 0;

                                  return (
                                    <React.Fragment key={`item-rep-ot-${otIndex}`}>

                                      {items.map((item, iIndex) => {
                                        const qty = parseFloat(item.total_quantity || 0);
                                        const amount = parseFloat(item.total_price || 0);
                                        const price = qty > 0 ? amount / qty : 0;

                                        orderTypeQty += qty;
                                        orderTypeAmount += amount;

                                        grandQty += qty;
                                        grandAmount += amount;

                                        // if(items[iIndex + 1] && items[iIndex + 1]?.food_type === "property" && item.food_type === "food") return <></>;
                                        return (
                                          <tr key={`item-rep-it-${iIndex}`}>
                                            {/* Branch Name */}
                                            {otIndex === 0 && iIndex === 0 ? <th className="text-capitalize">{branchName}</th> : <td></td>}
                                            {/* Order Type Name */}
                                            {<th>{orderTypeName}</th>}

                                            {/* Item Name */}
                                            {
                                              item.food_type === "food" ? (
                                                <td><strong>{item.food_item}</strong></td>
                                              ) : item.food_type === "property" ? <td>{item.food_item}</td> : <td>{item.food_item}</td>
                                            }

                                            {/* Quantity */}
                                            <td>{qty}</td>
                                            {/* Price */}
                                            <td>{formatPrice(price)}</td>
                                            {/* Amount */}
                                            <td>{formatPrice(amount)}</td>
                                          </tr>
                                        );
                                      })}

                                      {/* Order Type Total */}
                                      <tr style={{ background: "#e7f3f9" }}>
                                        <td></td>
                                        <td colSpan={2}><strong>{t('Total')}</strong></td>
                                        <td><strong>{orderTypeQty}</strong></td>
                                        <td></td>
                                        <td><strong>{formatPrice(orderTypeAmount)}</strong></td>
                                      </tr>
                                      <tr></tr>
                                    </React.Fragment>
                                  );
                                })}

                                {/* Branch Total */}
                                <tr style={{ background: "#e0e0e0" }}>
                                  <td colSpan={3}><strong>{branchName} Total</strong></td>
                                  <td><strong>{branchTotalQty}</strong></td>
                                  <td></td>
                                  <td><strong>{formatPrice(branchTotalAmount)}</strong></td>
                                </tr>
                                <tr></tr>
                              </React.Fragment>
                            );
                          })}

                          {/* Grand Total */}
                          <tr></tr>
                          <tr style={{ background: "#f8f9fa" }}>
                            <td></td>
                            <td></td>
                            <th>Grand Total</th>
                            <td><strong>{grandQty}</strong></td>
                            <td></td>
                            <td><strong>{formatPrice(grandAmount)}</strong></td>
                          </tr>

                        </tbody>

                      </table>

                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>

        {/* Print of Menu Mix Order Type Report */}
        <div ref={refThermal}>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      {siteName}
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      FROM&nbsp;
                      <Moment format="LL">{startDate}</Moment>
                      &nbsp;TO&nbsp;
                      <Moment format="LL">{endDate}</Moment>
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      Print Time: <Moment format="LLL">{new Date()}</Moment>
                    </span>
                  </div>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    Menu Mix Order Type
                  </span>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    {branch && branch.name}
                  </span>

                  <div>
                    <p className="mx-1 xsm-text table-text_pos text-capitalize border border-dark py-1 d-flex justify-content-between">
                      <span
                        className="font-weight-bold pl-1"
                        style={{ width: "40.5%" }}
                      >
                        Item
                      </span>
                      <span
                        className="font-weight-bold"
                        style={{ width: "19%" }}
                      >
                        Qty
                      </span>

                      <span
                        className="font-weight-bold"
                        style={{ width: "22.5%" }}
                      >
                        Price
                      </span>

                      <span
                        className="font-weight-bold pr-1"
                        style={{ width: "18%", textAlign: "right" }}
                      >
                        Amount
                      </span>
                    </p>
                  </div>
                  {/* Group Wise Report */}
                  {menuMixOrderTypeReport?.groupReport && Object.keys(menuMixOrderTypeReport?.groupReport).map((branchName) => {
                    if (!branchName) return null;
                    const orderTypes = menuMixOrderTypeReport?.groupReport[branchName];

                    let branchTotalQty = 0;
                    let branchTotalAmount = 0;

                    return (
                      <div key={branchName}>
                        {/* Branch Header */}
                        <div className="w-100 col-12 mt-2">
                          <span className="mx-2 d-flex font-weight-bold justify-content-center lg-text">
                            {branchName}
                          </span>
                        </div>

                        {/* Loop Order Types (Delivery / TakeAway etc.) */}
                        {Object.keys(orderTypes).map((orderType) => {
                          const categories = orderTypes[orderType];

                          return (
                            <div key={orderType}>
                              {/* Order Type */}
                              <div className="w-100 col-12 my-2">
                                <span className="mx-2 d-flex font-weight-bold justify-content-center text-decoration-underline table-text">
                                  {orderType}
                                </span>
                              </div>

                              {/* Loop Categories */}
                              {Object.keys(categories).map((categoryName) => {
                                const items = categories[categoryName];

                                let categoryQty = 0;
                                let categoryAmount = 0;

                                return (
                                  <div key={categoryName}>
                                    {/* Category Title */}
                                    <div className="w-100 col-12">
                                      <span className="mx-2 my-2 d-flex font-weight-bold justify-content-center text-decoration-underline table-text">
                                        {categoryName}
                                      </span>
                                    </div>

                                    {/* Items */}
                                    {items.map((item, idx) => {
                                      const qty = parseFloat(item.total_quantity || 0);
                                      const price = parseFloat(item.total_price || 0);
                                      const amount = qty * price;

                                      categoryQty += qty;
                                      categoryAmount += amount;

                                      branchTotalQty += qty;
                                      branchTotalAmount += amount;

                                      return (
                                        <div
                                          key={idx}
                                          className="text-capitalize w-100 d-flex justify-content-between p-1"
                                        >
                                          <span className="mx-1 sm-text" style={{ width: "40.2%" }}>
                                            {item.food_item}
                                          </span>
                                          <span className="mx-1 sm-text" style={{ width: "17%" }}>
                                            {qty}
                                          </span>
                                          <span className="mx-1 sm-text" style={{ width: "24%" }}>
                                            {price.toFixed(2)}
                                          </span>
                                          <span
                                            className="float-right sm-text pr-1"
                                            style={{ width: "18%", textAlign: "right" }}
                                          >
                                            {amount.toFixed(2)}
                                          </span>
                                        </div>
                                      );
                                    })}

                                    {/* Category Total */}
                                    <div className="mb-1 p-1 xsm-text font-weight-bold text-capitalize d-flex justify-content-between border border-dark">
                                      <span style={{ width: "41.5%" }}>Total</span>
                                      <span className="mx-2 ml-1" style={{ width: "17%" }}>
                                        {categoryQty}
                                      </span>
                                      <span style={{ width: "23%" }}></span>
                                      <span
                                        className="float-right"
                                        style={{ width: "18%", textAlign: "right" }}
                                      >
                                        {categoryAmount.toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}

                        {/* Branch Grand Total */}
                        <div>
                          <div className="mb-1 p-1 xsm-text font-weight-bold text-capitalize d-flex justify-content-between border border-dark">
                            <span style={{ width: "41.5%" }}>Grand Total</span>
                            <span className="mx-2 ml-1" style={{ width: "17%" }}>
                              {branchTotalQty}
                            </span>
                            <span style={{ width: "23%" }}></span>
                            <span
                              className="float-right"
                              style={{ width: "18%", textAlign: "right" }}
                            >
                              {branchTotalAmount.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <h3 className="text-center">Order Type Wise Report</h3>
                  {/* Item Wise Report  */}
                  {menuMixOrderTypeReport?.itemReport && Object.keys(menuMixOrderTypeReport?.itemReport).map((branchName) => {

                    if (!branchName) return null;

                    const orderTypes = menuMixOrderTypeReport?.itemReport[branchName];

                    let branchTotalQty = 0;
                    let branchTotalAmount = 0;

                    return (
                      <div key={branchName}>
                        {/* Branch Header */}
                        <div className="w-100 col-12 mt-2">
                          <span className="mx-2 d-flex font-weight-bold justify-content-center lg-text">
                            {branchName}
                          </span>
                        </div>

                        {/* Loop Order Types (Delivery / TakeAway etc.) */}
                        {Object.keys(orderTypes).map((orderType) => {
                          const items = orderTypes[orderType];

                          let orderTypeQty = 0;
                          let orderTypeAmount = 0;

                          return (
                            <div key={orderType}>
                              {/* Order Type */}
                              <div className="w-100 col-12 my-2">
                                <span className="mx-2 d-flex font-weight-bold justify-content-center text-decoration-underline table-text">
                                  {orderType}
                                </span>
                              </div>

                              {/* Items */}
                              {items.map((item, idx) => {
                                const qty = parseFloat(item.total_quantity || 0);
                                const amount = parseFloat(item.total_price || 0);
                                const price = qty > 0 ? amount / qty : 0;

                                orderTypeQty += qty;
                                orderTypeAmount += amount;

                                branchTotalQty += qty;
                                branchTotalAmount += amount;

                                return (
                                  <div
                                    key={idx}
                                    className="text-capitalize w-100 d-flex justify-content-between p-1"
                                  >
                                    <span className="mx-1 sm-text" style={{ width: "40.2%" }}>
                                      {item.food_item}
                                    </span>
                                    <span className="mx-1 sm-text" style={{ width: "17%" }}>
                                      {qty}
                                    </span>
                                    <span className="mx-1 sm-text" style={{ width: "24%" }}>
                                      {price.toFixed(2)}
                                    </span>
                                    <span
                                      className="float-right sm-text pr-1"
                                      style={{ width: "18%", textAlign: "right" }}
                                    >
                                      {amount.toFixed(2)}
                                    </span>
                                  </div>
                                );
                              })}

                              {/* Order Type Total */}
                              <div className="mb-1 p-1 xsm-text font-weight-bold text-capitalize d-flex justify-content-between border border-dark">
                                <span style={{ width: "41.5%" }}>Total</span>
                                <span className="mx-2 ml-1" style={{ width: "17%" }}>
                                  {orderTypeQty}
                                </span>
                                <span style={{ width: "23%" }}></span>
                                <span
                                  className="float-right"
                                  style={{ width: "18%", textAlign: "right" }}
                                >
                                  {orderTypeAmount.toFixed(2)}
                                </span>
                              </div>
                            </div>
                          );
                        })}

                        {/* Branch Grand Total */}
                        <div>
                          <div className="mb-1 p-1 xsm-text font-weight-bold text-capitalize d-flex justify-content-between border border-dark">
                            <span style={{ width: "41.5%" }}>Grand Total</span>
                            <span className="mx-2 ml-1" style={{ width: "17%" }}>
                              {branchTotalQty}
                            </span>
                            <span style={{ width: "23%" }}></span>
                            <span
                              className="float-right"
                              style={{ width: "18%", textAlign: "right" }}
                            >
                              {branchTotalAmount.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

const MenuMixCategoryWiseTable = ({
  menuMixCategoryWiseReport,
  generatedReport,
  branch,
  startDate,
  endDate,
  siteName,
  t,
  refThermal,
  reportViewOption
}) => {

  let grandTotal = {
    qty: 0,
    avgRate: 0,
    price: 0,
    totalPrice: 0,
    discount_amount: 0,
    totalAmount: 0,
    transactionCount: 0
  }

  return (
    <>
      <div className="d-none">
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {reportViewOption == "excel" && menuMixCategoryWiseReport && generatedReport && (
                  <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                    <div className="col-12 t-mb-15 mb-md-0 table-responsive">

                      <table
                        className="table table-bordered table-hover min-table-height mt-3"
                        id="menu-mix-category-wise-to-xls"
                      >

                        <thead className="align-middle">
                          <tr style={{ border: "0px" }}>
                            <th colSpan="11" style={{ border: "0px" }}>
                              <div className="row">
                                <div className="col-12">
                                  <h3 className="text-center mb-0">{siteName}</h3>
                                  <h3 className="text-center mt-0">Menu Mix Category Wise Report</h3>
                                  <h4 className="text-center mt-0">{branch && branch?.length ? branch.map(b=>b?.name).join(", ") : "All Branches"}</h4>
                                  <p className="text-center">
                                    FROM <Moment format="LL">{startDate}</Moment>
                                    &nbsp;TO&nbsp;
                                    <Moment format="LL">{endDate}</Moment>
                                  </p>
                                </div>
                              </div>
                            </th>
                          </tr>

                          <tr>
                            <th>{t("Branch")}</th>
                            <th>{t("Group Name")}</th>
                            <th>{t("Branch")}</th>
                            <th>{t("Item")}</th>
                            <th>{t("Qty")}</th>
                            <th>{t("Avg. Rate")}</th>
                            <th>{t("Price")}</th>
                            <th>{t("Total")}</th>
                            <th>{t("Discount(%)")}</th>
                            <th>{t("Amount")}</th>
                            <th>{t("# of Trans")}</th>
                          </tr>
                        </thead>


                        <tbody className="align-middle">
                          {menuMixCategoryWiseReport?.[0] &&
                            menuMixCategoryWiseReport[0] && Object.keys(menuMixCategoryWiseReport[0]).map((group,index)=>{
                              return(
                                <>
                                  <tr key={index}>
                                    <td><strong>{group}</strong></td>
                                  </tr>   
                                  {menuMixCategoryWiseReport[0][group] && Object.entries(menuMixCategoryWiseReport[0][group]).map(([groupName, items], gIndex) => {
        
                                    let categoryGroupTotal = {
                                      qty: 0,
                                      avgRate: 0,
                                      price: 0,
                                      totalPrice: 0,
                                      discount_amount: 0,
                                      totalAmount: 0,
                                      transactionCount: 0
                                    }
        
                                    return (
                                      <React.Fragment key={gIndex}>
        
                                        {items.map((item, iIndex) => {
        
                                          const qty = parseFloat(item.quantity || 0);
                                          const avgRate = parseFloat(item.avg_rate || 0);
                                          const price = parseFloat(item.price || 0);
                                          const totalPrice = parseFloat(item.total || 0);
                                          const discountAmount = parseFloat(item.discount_amount || 0);
                                          const amount = parseFloat(item.total - item.discount_amount || 0);
                                          const discountPercent = totalPrice > 0 ? (discountAmount / totalPrice) * 100 : 0;
                                          const trans = parseFloat(item.no_of_transaction || 0);
        
                                          // Calculate group totals
                                          categoryGroupTotal.qty += qty;
                                          categoryGroupTotal.avgRate += avgRate;
                                          categoryGroupTotal.price += price;
                                          categoryGroupTotal.totalPrice += totalPrice;
                                          categoryGroupTotal.discount_amount += discountAmount;
                                          categoryGroupTotal.totalAmount += amount;
                                          categoryGroupTotal.transactionCount += trans;
        
                                          // Grand totals
                                          grandTotal.qty += qty;
                                          grandTotal.avgRate += avgRate;
                                          grandTotal.price += price;
                                          grandTotal.totalPrice += totalPrice;
                                          grandTotal.discount_amount += discountAmount;
                                          grandTotal.totalAmount += amount;
                                          grandTotal.transactionCount += trans;
        
        
                                          return (
                                            <tr key={`${gIndex}-${iIndex}`}>
                                              <td className="text-center"></td>
                                              {iIndex === 0 ? <td className="align-middle text-center font-weight-bold"><strong>{groupName}</strong></td> : <td></td>}
                                              <td>{item.branch?.name}</td>
                                              <td>{item.food_item}</td>
                                              <td className="text-center">{qty}</td>
                                              <td className="text-right">{formatPrice(avgRate)}</td>
                                              <td className="text-right">{formatPrice(price)}</td>
                                              <td className="text-right">{formatPrice(totalPrice)}</td>
                                              <td className="text-center">{discountAmount} ({discountPercent.toFixed(1)})%</td>
                                              <td className="text-right">{formatPrice(amount)}</td>
                                              <td className="text-center">{item.no_of_transaction || 0}</td>
                                            </tr>
                                          );
                                        })}
        
                                        {/* Category Total  */}
        
                                        <tr></tr>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <th className="text-right font-weight-bold">{groupName} Total</th>
                                          <th className="text-center font-weight-bold">{categoryGroupTotal.qty}</th>
        
                                          {/* Total Avg Rate */}
                                          <th className="text-right font-weight-bold">0</th>
        
                                          <th className="text-right font-weight-bold">{formatPrice(categoryGroupTotal.price)}</th>
        
                                          <th className="text-right font-weight-bold">{formatPrice(categoryGroupTotal.totalPrice)}</th>
        
                                          <th className="text-center font-weight-bold">{categoryGroupTotal.discount_amount.toFixed(2)}{" "}{"(" + ((categoryGroupTotal.discount_amount / categoryGroupTotal.totalPrice) * 100).toFixed(1) + " % )"}</th>
        
                                          <th className="text-right font-weight-bold">{formatPrice(categoryGroupTotal.totalAmount)}</th>
        
                                          <th className="text-center font-weight-bold">{categoryGroupTotal.transactionCount}</th>
                                        </tr>
                                        <tr></tr>
        
                                      </React.Fragment>
                                    )
                                  })}
                                </>
                              )
                            })
                          }

                          {/* Grand Total */}
                          <tr></tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <th className="text-right font-weight-bold">Grand Total</th>
                            <th className="text-center font-weight-bold">
                              {grandTotal.qty}
                            </th>
                            <th className="text-right font-weight-bold">
                              0
                            </th>
                            <th className="text-right font-weight-bold">
                              {formatPrice(grandTotal.price)}
                            </th>
                            <th className="text-right font-weight-bold">
                              {formatPrice(grandTotal.totalPrice)}
                            </th>
                            <th className="text-center font-weight-bold">
                              {grandTotal.discount_amount.toFixed(2)} {" "}{"( " + ((grandTotal.discount_amount / grandTotal.totalPrice) * 100).toFixed(1) + " % )"}
                            </th>
                            <th className="text-right font-weight-bold">
                              {formatPrice(grandTotal.totalAmount)}
                            </th>
                            <th className="text-center font-weight-bold">
                              {grandTotal.transactionCount}
                            </th>
                          </tr>

                          <tr></tr>

                          <tr>
                            <th>{t("Item")}</th>
                            <th>{t("Qty")}</th>
                            <th>{t("Total")}</th>
                            <th>{t("Discount")}</th>
                            <th>{t("Amount")}</th>
                          </tr>

                          {menuMixCategoryWiseReport?.[1] &&
                            menuMixCategoryWiseReport[1]?.length && menuMixCategoryWiseReport[1].map((item,ind)=>{
                              return(
                                <tr key={ind}>
                                  <td>{item.food_item}</td>
                                  <td>{item.quantity}</td>
                                  <td>{item.total}</td>
                                  <td>{item.discount_amount}</td>
                                  <td>{Number(item.total) - Number(item.discount_amount)}</td>
                                </tr>
                              )
                            })
                          }

                        </tbody>

                      </table>

                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>

        {/* =============== Print ================ */}
        <div ref={refThermal}>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      {siteName}
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      FROM&nbsp;
                      <Moment format="LL">{startDate}</Moment>
                      &nbsp;TO&nbsp;
                      <Moment format="LL">{endDate}</Moment>
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      Print Time: <Moment format="LLL">{new Date()}</Moment>
                    </span>
                  </div>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                    Menu Mix Categories Wise Report
                  </span>

                  <div>
                    <p className="mx-1 xsm-text table-text_pos text-capitalize border border-dark py-1 d-flex justify-content-between">
                      <span
                        className="font-weight-bold pl-1"
                        style={{ width: "25%" }}
                      >
                        Item
                      </span>
                      <span
                        className="font-weight-bold text-center"
                        style={{ width: "8%" }}
                      >
                        Qty
                      </span>
                      <span
                        className="font-weight-bold text-right"
                        style={{ width: "11%" }}
                      >
                        Avg.Rate
                      </span>
                      <span
                        className="font-weight-bold text-right"
                        style={{ width: "11%" }}
                      >
                        Price
                      </span>
                      <span
                        className="font-weight-bold text-right"
                        style={{ width: "13%" }}
                      >
                        Total
                      </span>
                      <span
                        className="font-weight-bold text-center"
                        style={{ width: "14%" }}
                      >
                        Discount
                      </span>

                      <span
                        className="font-weight-bold pr-1 text-right"
                        style={{ width: "18%" }}
                      >
                        Amount
                      </span>
                    </p>
                  </div>

                  {
                    menuMixCategoryWiseReport && (
                      <>
                      {/* Group Wise Report */}
                      {reportViewOption !== "excel" && menuMixCategoryWiseReport?.[0] &&
                        Object.keys(menuMixCategoryWiseReport[0])?.length && Object.keys(menuMixCategoryWiseReport[0]).map((group)=>{
                          return (
                            <>
                              <div className="w-100 text-center border-bottom border-dark border mb-2">
                                {group}
                              </div>
                              {menuMixCategoryWiseReport[0][group] && Object.entries(menuMixCategoryWiseReport[0][group]).map(([groupName, items], gIndex) => {
            
                                let categoryGroupTotal = {
                                  qty: 0,
                                  avgRate: 0,
                                  price: 0,
                                  totalPrice: 0,
                                  discount_amount: 0,
                                  totalAmount: 0,
                                  transactionCount: 0
                                }
            
                                return (
                                  <div key={gIndex}>
                                    {/* Group Header */}
                                    <div className="w-100 col-12 mt-2">
                                      <span className="mx-2 d-flex font-weight-bold justify-content-center lg-text text-uppercase text-decoration-underline">
                                        {groupName}
                                      </span>
                                    </div>
            
                                    {items.map((item, iIndex) => {
            
                                      const qty = parseFloat(item.quantity || 0);
                                      const price = parseFloat(item.price || 0);
                                      const avgRate = parseFloat(item.avg_rate || 0);
                                      const totalPrice = parseFloat(item.total || 0);
                                      const discountAmount = parseFloat(item.discount_amount || 0);
                                      const amount = parseFloat(item.total - item.discount_amount || 0);
            
                                      // Calculate group totals
                                      categoryGroupTotal.qty += qty;
                                      categoryGroupTotal.avgRate = 0;
                                      categoryGroupTotal.price += price;
                                      categoryGroupTotal.totalPrice += totalPrice;
                                      categoryGroupTotal.discount_amount += discountAmount;
                                      categoryGroupTotal.totalAmount += amount;
            
                                      // Grand totals
                                      grandTotal.qty += qty;
                                      grandTotal.price += price;
                                      grandTotal.totalPrice += totalPrice;
                                      grandTotal.discount_amount += discountAmount;
                                      grandTotal.totalAmount += amount;
            
            
                                      return (
                                        <div className="text-capitalize w-100 d-flex justify-content-between py-1" key={iIndex}>
                                          <span className="mx-1 sm-text font-weight-bold text-wrap text-break" style={{ width: "25%" }}>{item.food_item}</span>
                                          <span className="mx-1 sm-text font-weight-bold text-center" style={{ width: "8%" }}>{qty}</span>
                                          <span className="mx-1 sm-text font-weight-bold text-right" style={{ width: "11%" }}>{formatPrice(avgRate)}</span>
                                          <span className="mx-1 sm-text font-weight-bold text-right" style={{ width: "11%" }}>{formatPrice(price)}</span>
                                          <span className="mx-1 sm-text font-weight-bold text-right" style={{ width: "13%" }}>{formatPrice(totalPrice)}</span>
                                          <span className="mx-1 sm-text font-weight-bold text-center" style={{ width: "14%" }}>{formatPrice(discountAmount)}</span>
                                          <span className="mx-1 sm-text font-weight-bold text-right pr-1" style={{ width: "18%" }}>{formatPrice(amount)}</span>
                                        </div>
                                      )
                                    })}
            
                                    {/* Group Total */}
                                    <div className="mb-1 sm-text fk-print-text_pos fk-print-text--bold text-capitalize d-flex justify-content-between border-top border-dark">
                                      <span style={{ width: "25%" }}>Total</span>
                                      <span className="text-center" style={{ width: "8%" }}>{categoryGroupTotal.qty}</span>
                                      <span className="text-right" style={{ width: "11%" }}>0</span>
                                      <span className="text-right" style={{ width: "11%" }}>{formatPrice(categoryGroupTotal.price)}</span>
                                      <span className="text-right" style={{ width: "13%" }}>{formatPrice(categoryGroupTotal.totalPrice)}</span>
                                      <span className="text-center" style={{ width: "14%" }}>{formatPrice(categoryGroupTotal.discount_amount)}</span>
                                      <span className="float-right text-right pr-1" style={{ width: "18%" }}>{formatPrice(categoryGroupTotal.totalAmount)}</span>
                                    </div>
                                  </div>
                                )
                              })}
                            </>
                          )
                        })
                      }

                      {/* Grand Total */}
                      <div className="mt-2">
                        <div className="mb-1 p-1 sm-text font-weight-bold text-capitalize d-flex justify-content-between border border-dark">
                          <span style={{ width: "25%" }}>Grand Total</span>
                          <span className="text-center" style={{ width: "8%" }}>{grandTotal.qty}</span>
                          <span className="text-right" style={{ width: "11%" }}>0</span>
                          <span className="text-right" style={{ width: "11%" }}>{formatPrice(grandTotal.price)}</span>
                          <span className="text-right" style={{ width: "13%" }}>{formatPrice(grandTotal.totalPrice)}</span>
                          <span className="text-center" style={{ width: "14%" }}>{formatPrice(grandTotal.discount_amount)}</span>
                          <span className="float-right text-right pr-1" style={{ width: "18%" }}>{formatPrice(grandTotal.totalAmount)}</span>
                        </div>
                      </div>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};


